export const getIsDragging = state => state.dragndrop
